module["exports"] = [
  "#",
  "##"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/nb_NO/address/building_number.js
// module id = 888
// module chunks = 0